import { Typography } from '@/components/ui/typography';

import { Skeleton } from './skeleton';

export function Title({ title }: { title: string }) {
  return (
    <Typography as="h1" variant="h5">
      {title}
    </Typography>
  );
}

Title.Skeleton = function TitleSkeleton() {
  return <Skeleton className="h-6 w-80" />;
};
